import { Link } from "react-router-dom";


const Footer = () => {
    return (
        <footer>
        <div className="max-w-[1500px] mx-auto px-[5vw] lg:px-20">
            
            <div className="flex flex-col md:flex-row items-start">
                <h2 className="mb-3 mx-3 md:max-w-[400px] font-[500] text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl tracking-wide">
                    Etiam et id tincidunt faucibus mollis a sociis pretium fermentum quis magna faucibus lacus.
                </h2>
                <div className = 'flex flex-wrap sm:flex-no-wrap flex-grow w-full justify-between'>
                    
                    <div className = 'flex flex-col mx-3 mb-3'>
                        <h2 className="mb-3 max-w-[400px] font-[500] text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl tracking-wide">
                            Marketplace
                        </h2>
                        <ul className="flex flex-col">
                            <li>
                                <Link className="text-gray-400 text-sm md:text-base hover:text-white" to="/">
                                    Home
                                </Link>
                            </li>
                            <li>
                                <Link className="text-gray-400 text-sm md:text-base hover:text-white" to="/activity">
                                    Activity
                                </Link>
                            </li>
                            <li>
                                <Link className="text-gray-400 text-sm md:text-base hover:text-white" to="/collections">
                                    Discover
                                </Link>
                            </li>
                            <li>
                                <Link className="text-gray-400 text-sm md:text-base hover:text-white" to="/learnmore">
                                    Learn More
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div className = 'flex flex-col mx-3 mb-3'>
                        <h2 className="mb-3 max-w-[400px] font-[500] text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl tracking-wide">
                            Company
                        </h2>
                        <ul className="flex flex-col">
                            <li>
                                <Link className="text-gray-400 text-sm md:text-base hover:text-white" to="/aboutus">
                                    About Us
                                </Link>
                            </li>
                            <li>
                                <Link className="text-gray-400 text-sm md:text-base hover:text-white" to="/services">
                                    Services
                                </Link>
                            </li>
                            <li>
                                <Link className="text-gray-400 text-sm md:text-base hover:text-white" to="/portfolio">
                                    Portfolio
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div className = 'flex flex-col mx-3 mb-3'>
                        <h2 className="mb-3 max-w-[400px] font-[500] text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl tracking-wide">
                            Contact
                        </h2>
                        <ul className="flex flex-col">
                            <li>
                                <a href = '/' target='_blank' rel='noreferrer' className="text-gray-400 text-sm md:text-base hover:text-white" to="/">
                                    Facebook
                                </a>
                            </li>
                            <li>
                                <a href = '/' target='_blank' rel='noreferrer' className="text-gray-400 text-sm md:text-base hover:text-white" to="/">
                                    Instagram
                                </a>
                            </li>
                            <li>
                                <a href = '/' target='_blank' rel='noreferrer' className="text-gray-400 text-sm md:text-base hover:text-white" to="/">
                                    Twitter
                                </a>
                            </li>
                            <li>
                                <a href = '/' target='_blank' rel='noreferrer' className="text-gray-400 text-sm md:text-base hover:text-white" to="/">
                                    Email
                                </a>
                            </li>
                        </ul>
                    </div>

                </div>

            </div>

            <div className="flex justify-between mt-5 pt-5 pb-10 border-t-[1px] border-gray-300">
                    <div className="flex">
                        <a href="/" target='' rel='noreferrer' className="mx-3 text-gray-300">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="w-[30px] h-[30px]" viewBox="0 0 448 512">
                                <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"/>
                            </svg>
                        </a>                   
                        <a href="/" target='' rel='noreferrer' className="mx-3 text-gray-300">     
                            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="w-[30px] h-[30px]" viewBox="0 0 448 512">
                                <path d="M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z"/>
                            </svg>
                        </a>
                        <a href="/" target='' rel='noreferrer' className="mx-3 text-gray-300">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="w-[30px] h-[30px]" viewBox="0 0 448 512">
                                <path d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-48.9 158.8c.2 2.8.2 5.7.2 8.5 0 86.7-66 186.6-186.6 186.6-37.2 0-71.7-10.8-100.7-29.4 5.3.6 10.4.8 15.8.8 30.7 0 58.9-10.4 81.4-28-28.8-.6-53-19.5-61.3-45.5 10.1 1.5 19.2 1.5 29.6-1.2-30-6.1-52.5-32.5-52.5-64.4v-.8c8.7 4.9 18.9 7.9 29.6 8.3a65.447 65.447 0 0 1-29.2-54.6c0-12.2 3.2-23.4 8.9-33.1 32.3 39.8 80.8 65.8 135.2 68.6-9.3-44.5 24-80.6 64-80.6 18.9 0 35.9 7.9 47.9 20.7 14.8-2.8 29-8.3 41.6-15.8-4.9 15.2-15.2 28-28.8 36.1 13.2-1.4 26-5.1 37.8-10.2-8.9 13.1-20.1 24.7-32.9 34z"/>
                            </svg>
                        </a>
                    </div>
                    <p className="text-gray-300 text-sm">Copyright 2022 fsowmo</p>
                </div>    

        </div>
        </footer>
    )
}

export default Footer;